<style lang="scss" scoped>
  @import "../../../scss/variables";

  .cart-table {
    width: 100%;

    .cell-actions {
      width: 120px;
    }
  }

  .loading-overlay {
    background-color: rgba(255, 255, 255, 0.8);
    display: flex;
    position: absolute;
    padding: 30px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    z-index: 100;
  }

  .hiddenfile {
    width: 0px;
    height: 0px;
    overflow: hidden;
  }

  .error-box {
    background-color: lighten($red, 50%);
    color: $red;
  }
</style>

<template>
  <div>

    <md-dialog ref="sendSummaryDialog">
      <md-dialog-title>Skriv inn e-post til mottaker</md-dialog-title>

      <md-dialog-content>
        <md-input-container :class="{'md-input-invalid': errors.hasError('email')}">
          <label>E-post</label>
          <md-input class="md-input-block" v-model="prompt.email"></md-input>
          <span class="md-error" v-if="errors.hasError('email')">{{ errors.getFirstError('email') }}</span>
        </md-input-container>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="closeDialog('sendSummaryDialog')" :disabled="state.is('sending')">Cancel</md-button>
        <md-button class="md-primary" @click="sendNotification()" :disabled="state.is('sending')">
          <span v-if="state.is('sending')">Sender...</span>
          <span v-else>Send</span>
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <div class="fz24 light mt2">Ordredetaljer</div>
    <p class="mt2 mb3">
      Her finner du en detaljert overiskt over din ordre. Du kan også håndtere filene for ordren her.</p>
    <div v-if="order">

      <div class="clearfix mxn2">
        <div class="col col-4 px2">
          <div class="card sh1 rounded p3 mb3">

            <div>
              <div class="fz24 light mb2">Detaljer</div>

              <div class="mb2">
                <div class="fz12">Navn på bestilling</div>
                <div>{{ order.title }}</div>
              </div>

              <div class="mb2">
                <div class="fz12">Navn/firma (kunde)</div>
                <div v-if="order.data.client.name">{{ order.data.client.name }}</div>
                <div class="italic" v-else>Ikke oppgitt...</div>
              </div>

              <div class="mb2">
                <div class="fz12">E-post (kunde)</div>
                <div v-if="order.data.client.email">{{ order.data.client.email }}</div>
                <div class="italic" v-else>Ikke oppgitt...</div>
              </div>

              <div class="mb2">
                <div class="fz12">Plassert</div>
                <div>{{ toLocaleDate(order.created_at.time) }}</div>
              </div>
            </div>

            <div class="mt3">
              <div class="fz24 light mb2">Merknader</div>
              <pre class="bg-light-grey p3 rounded" v-if="order.notes">{{ order.notes }}</pre>
              <pre class="bg-light-grey p3 rounded" v-else="">Ingen merknader...</pre>
            </div>

            <div class="mt3">
              <div class="fz24 light mb2">Ordrebekreftelse</div>
              <!--
              <div class="mb2">
                <md-button class="md-raised md-primary btn-block" @click.native="openDialog('sendSummaryDialog')" id="send-btn">
                  <md-icon class="mr1">send</md-icon>
                  <span>Send til kunde</span>
                </md-button>
              </div>
              -->
              <md-button class="md-raised md-primary btn-block" @click.native="downloadOrder()">
                <md-icon class="mr1">file_download</md-icon>
                <span>Last ned som PDF</span>
              </md-button>
            </div>

          </div>

          <div class="card sh1 rounded p3">
            <div class="fz24 light mb2">Leveringsadresse</div>

            <div v-if="order.data.delivery_address">
              <div class="mb2">
                <small class="text-grey">Navn</small>
                <div>{{ order.data.delivery_address.name }}</div>
              </div>
              <div class="mb2">
                <small class="text-grey">Adresse</small>
                <div>{{ order.data.delivery_address.address }}</div>
              </div>
              <div class="mb2">
                <small class="text-grey">Postnummer</small>
                <div>{{ order.data.delivery_address.zip }}</div>
              </div>
              <div class="mb2">
                <small class="text-grey">Poststed</small>
                <div>{{ order.data.delivery_address.city }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col col-8 px2">

          <div class="card sh1 rounded p3 relative">

            <div class="loading-overlay" v-if="state.is('working')">
              <md-spinner md-indeterminate></md-spinner>
            </div>

            <div class="fz24 light">Behandle filer</div>
            <p class="mt2 mb2">
              Last opp trykklare filer ordren.
            </p>
            <p class="mt2 mb2">
              Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.
            </p>
            <div class="fz16 bold mb2 mt3">Trykkfiler for produkter:</div>
            <div class="clearfix relative">
              <div class="card rounded sh1" v-if="order.lines.length > 0">

                <table class="cart-table" cellpadding="0" cellspacing="0">
                  <thead>
                  <tr class="text-grey ">
                    <th class="border-bottom border-light-grey px3 py2 light left-align">Produkt</th>
                    <th class="border-bottom border-light-grey py2 light">Antall</th>
                    <th class="border-bottom border-light-grey py2 light">Handlinger</th>
                  </tr>
                  </thead>
                  <tbody v-for="(orderLine, index) in order.lines">
                  <tr class="@bg-light-blue">
                    <td class="p3 border-bottom border-light-grey">
                      <div class="fz24 light mb1">{{ orderLine.product.name }}</div>
                      <div>{{ orderLine.parameters_text }}</div>
                    </td>
                    <td class="border-bottom border-light-grey center">
                      {{ orderLine.quantity }}
                    </td>
                    <td class="border-bottom border-light-grey cell-actions center">
                      <md-button type="file" class="md-icon-button text-blue"
                                 @click.native="pickFile(orderLine.id, 'order_line')">
                        <md-tooltip>Last opp ny trykkfil</md-tooltip>
                        <md-icon>file_upload</md-icon>
                      </md-button>
                      <div class="hiddenfile">
                        <input type="file" :id="'file_order_line_'+orderLine.id"
                               @change="onFileChange($event, orderLine.id, 'order_line')">
                      </div>
                    </td>
                  </tr>
                  <tr v-for="(attachment, attIndex) in orderLine.attachments">
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey" colspan="2">
                      <div class="bold mb1">Vedlegg {{ attIndex + 1 }}:</div>
                      <a :href="attachment.artworks[0].href" target="_blank">{{ attachment.artworks[0].original_filename
                        }}</a>
                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <md-button type="file" class="md-icon-button text-grey"
                                 @click.native="deleteAttachment(index, attachment.id, 'order_line')">
                        <md-tooltip>Slett vedlegg</md-tooltip>
                        <md-icon>delete</md-icon>
                      </md-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="fz16 bold mb2 mt3">Andre filer:</div>
            <div class="clearfix relative">
              <div class="card rounded sh1" v-if="order.lines.length > 0">

                <table class="cart-table" cellpadding="0" cellspacing="0">
                  <thead>
                  <tr class="text-grey ">
                    <th class="border-bottom border-light-grey px3 py2 light left-align">Fil</th>
                    <th class="border-bottom border-light-grey py2 light">Handlinger</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(attachment, attIndex) in order.attachments">
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <div class="bold mb1">Vedlegg {{ attIndex + 1 }}:</div>
                      <a :href="attachment.artworks[0].href" target="_blank">{{ attachment.artworks[0].original_filename
                        }}</a>
                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey center">
                      <md-button type="file" class="md-icon-button text-grey"
                                 @click.native="deleteAttachment(attIndex, attachment.id, 'order')">
                        <md-tooltip>Slett vedlegg</md-tooltip>
                        <md-icon>delete</md-icon>
                      </md-button>
                    </td>
                  </tr>
                  <tr>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey">
                      <md-button class="md-raised" @click.native="pickFile(order.id, 'order')">
                        Last opp ny fil
                      </md-button>

                      <div class="hiddenfile">
                        <input type="file" :id="'file_order_'+order.id"
                               @change="onFileChange($event, order.id, 'order')">
                      </div>

                    </td>
                    <td class="px3 py2 bg-light-grey border-bottom border-middle-grey center">

                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="card sh1 rounded p3 mt3 pb4">
            <div class="fz24 light">Ordreoversikt</div>

            <table class="cart-table" cellpadding="0" cellspacing="0">
              <thead>
              <tr class="text-grey ">
                <th class="border-bottom border-light-grey "></th>
                <th class="border-bottom border-light-grey py2 light left-align">Produkt</th>
                <th class="border-bottom border-light-grey py2 light">Antall</th>
                <th class="border-bottom border-light-grey py2 light left-align">Pris pr. stk.</th>
                <th class="border-bottom border-light-grey py2 light left-align" light>Total</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(orderLine, index) in order.lines" class="@bg-light-blue">
                <td class="cell-image p2">
                  <img class="rounded pointer" :src="getThumbnail(orderLine.product)" width="80" height="80"/>
                </td>
                <td>
                  <div class="fz18 mb1">{{ orderLine.product.name }}</div>
                  <div>{{ orderLine.parameters_text }}</div>
                </td>
                <td class="center px3">
                  {{ orderLine.quantity }}
                </td>
                <td>
                  <div class="fz24 light text-grey truncate">kr {{ toLocale(orderLine.unit_price / 100) }},-</div>
                </td>
                <td>
                  <div class="fz24 light text-blue truncate">kr {{ toLocale(orderLine.total / 100) }},-</div>
                </td>
              </tr>
              </tbody>
            </table>
            <table class="full-width">
              <tbody>
              <tr>
                <td class="border-top border-light-grey" style="width: 50%"></td>
                <td class="border-top border-light-grey">
                  <div class="fz24 light mb1 text-grey pt3 truncate">kr {{ toLocale(order.net_total / 100) }},-</div>
                  <div class="text-grey">Total eksl. MVA</div>
                </td>
                <td class="border-top border-light-grey">
                  <div class="fz24 light mb1 text-grey pt3 truncate">kr {{ toLocale(order.vat_total / 100) }},-</div>
                  <div class="text-grey">MVA</div>
                </td>
                <td class="border-top border-light-grey pt3">
                  <div class="fz24 light mb1 text-blue truncate">kr {{ toLocale(order.gross_total / 100) }},-</div>
                  <div class="text-grey">Total inkl. MVA</div>
                </td>
              </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>

    </div>
    <div class="p3 center" v-else>
      <md-spinner md-indeterminate></md-spinner>
    </div>
  </div>
</template>

<script>
  import apiOrder from '@/js/api/order';
  import apiAttachment from '@/js/api/attachment';
  import apiNotifications from '@/js/api/notifications';
  import State from '@/js/helpers/state';
  import Errors from '@/js/helpers/errors';
  import hasPrices from '@/js/mixins/hasPrices';
  import hasPictures from '@/js/mixins/hasPictures';
  import hasDialogs from '@/js/mixins/hasDialogs';

  export default {
    mixins: [hasPrices, hasPictures, hasDialogs],

    data() {
      return {
        state: new State(),
        errors: new Errors(),
        order: null,
        prompt: {
          email: '',
        },
      };
    },

    mounted() {
      // this.state.start('loading');
      apiOrder.show(this.$route.params.orderId).then(this.onFetchSuccess);
    },

    methods: {
      onFetchSuccess(response) {
        this.order = response.data;
        this.prompt.email = this.order.data.client.email;
        // this.state.stop('loading');
      },

      downloadOrder() {
        const url = `${process.env.API_URL}order-pdfs/${this.order.uuid}`;
        window.open(url);
      },

      sendNotification() {
        this.state.start('sending');

        apiNotifications.sendOrderClientSummary(this.order.id, this.prompt.email)
          .then((response) => {
            this.state.stop('sending');
            this.closeDialog('sendSummaryDialog');
            snack('Ordrebekreftelse sendt!');
          })
          .catch((error) => {
            this.state.stop('sending');
            if (error.response !== undefined) {
              this.errors.setErrors(error.response.data.errors);
            }
          });
      },

      pickFile(id, type) {
        document.getElementById(`file_${type}_${id}`).click();
      },

      onFileChange(e, id, type) {
        const element = document.getElementById(`file_${type}_${id}`);

        if (element.files[0] === undefined) {
          return;
        }

        const data = new FormData();

        data.append('attachable_id', id);
        data.append('attachable_type', type);
        data.append('attachment', element.files[0]);

        this.state.start('working');

        apiAttachment.store(data).then((response) => {
          if (type === 'order') {
            this.order.attachments.push(response.data.data);
          } else {
            const index = _.findIndex(this.order.lines, o => o.id === id);
            this.order.lines[index].attachments.push(response.data.data);
          }
        }).then(() => {
          this.state.stop('working');
        });
      },

      deleteAttachment(itemIndex, id, type) {
        this.state.start('working');

        apiAttachment.remove(id).then((response) => {
          if (type === 'order') {
            const attachments = this.order.attachments;
            const index = _.findIndex(attachments, o => o.id === id);
            attachments.splice(index, 1);
          } else {
            const attachments = this.order.lines[itemIndex].attachments;
            const index = _.findIndex(attachments, o => o.id === id);
            attachments.splice(index, 1);
          }
        }).then(() => {
          this.state.stop('working');
        });
      },

      toLocaleDate(date) {
        return moment(date).format('Do MMMM YYYY \\k\\l. HH:mm');
      },
    },
  };
</script>



// WEBPACK FOOTER //
// ViewOrder.vue?7de7ef72